import { Injectable } from '@angular/core';

import { Order } from 'src/app/shared';
import { OrderService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class DownloadOrdersResolver  {
  constructor(private orderService: OrderService) {}
  async resolve(): Promise<Order[]> {
    try {
      return await this.orderService.getDownloadOrders();
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
